// Build keyword-rich anchor links from an industry page → every city hub.
// Centralized so all 19 industry marketing pages share the same anchor-text
// convention and we don't drift across routes.
import { CITY_HUB_ROUTES } from "@/lib/cityHubRoutes";
import type { CityKey } from "@/lib/citiesData";

const CITY_NAMES: Record<CityKey, string> = {
  "colorado-springs": "Colorado Springs",
  monument: "Monument",
  "castle-rock": "Castle Rock",
  parker: "Parker",
  falcon: "Falcon",
  "woodland-park": "Woodland Park",
  fountain: "Fountain",
  denver: "Denver",
  aurora: "Aurora",
  boulder: "Boulder",
  "fort-collins": "Fort Collins",
  pueblo: "Pueblo",
} as Record<CityKey, string>;

export type IndustryCityLink = { to: string; label: string; city: string };

/**
 * Returns one link per city that has a dedicated digital-marketing hub,
 * with anchor text "[industry] marketing in [City]".
 */
export function buildIndustryCityLinks(industry: string): IndustryCityLink[] {
  return Object.entries(CITY_HUB_ROUTES)
    .map(([slug, to]) => {
      const name = CITY_NAMES[slug as CityKey] ?? slug;
      return {
        to: to as string,
        city: name,
        label: `${industry} marketing in ${name}`,
      };
    });
}
